import { useRouter, useRoute } from 'vue-router';
import { computed, ref, onMounted } from 'vue';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4c3f8898"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "system-notification-detail-content"
};
const _hoisted_2 = {
  class: "detail-content"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "model"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "是,自发送时间起", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "天", -1));
const _hoisted_7 = {
  key: 0,
  class: "btn-content"
};
import NoEditor from '@/views/systemNotification/components/NoEditor.vue';
import { OK, getSessionStorage, dateFormat } from '@/common';
import { postAddInformationNotice, postItemInformationNotice } from '@/api/systemNotification';
import { message } from 'ant-design-vue';
import dayjs from 'dayjs';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const isType = computed(() => {
      var _route$query;
      return ((_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.type) == 'add';
    });
    const notificationRef = ref();
    const getUserName = () => {
      const userInfo = JSON.parse(getSessionStorage('userInfo'));
      return userInfo.name;
    };
    const sendTypeList = [{
      label: '即时发送',
      value: 0
    }, {
      label: '定时发送',
      value: 1
    }];
    const publisherList = [{
      label: '系统管理员',
      value: '系统管理员'
    }, {
      label: '当前用户',
      value: getUserName()
    }];
    const notificationForm = ref({
      createUser: '系统管理员',
      isDelay: 0,
      scheduleSendTime: '',
      isForcePopover: 1,
      forcePopoverTimeLimit: 1,
      title: '',
      content: ''
    });
    const ImageUrlMap = ref();
    const disabled = ref(false);
    const getImageUrlMap = data => {
      ImageUrlMap.value = data;
    };
    const toSystemNotification = () => {
      router.push({
        name: 'systemNotification'
      });
    }; // 跳转发布通知页面
    const sendSystemMessage = () => {
      notificationRef.value.validate().then(async () => {
        const params = {
          ...notificationForm.value,
          scheduleSendTime: notificationForm.value.isDelay ? dayjs(notificationForm.value.scheduleSendTime).format(dateFormat) : ''
        };
        try {
          const {
            msg,
            code
          } = await postAddInformationNotice(params);
          if (code === OK) {
            message.success(msg);
            toSystemNotification();
          } else {
            message.error(msg);
          }
        } catch (e) {}
      });
    };
    const getFormData = async id => {
      try {
        const {
          data,
          code,
          msg
        } = await postItemInformationNotice({
          id
        });
        if (code === OK) {
          notificationForm.value = {
            ...data
          };
        } else {
          message.error(msg);
        }
      } catch (e) {}
    };
    onMounted(() => {
      const type = route.query.type;
      disabled.value = type === 'look';
      if (type != 'add' && route.query.id) {
        var _route$query2;
        const id = Number((_route$query2 = route.query) === null || _route$query2 === void 0 ? void 0 : _route$query2.id);
        getFormData(id);
      }
    });
    return (_ctx, _cache) => {
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_radio_group = _resolveComponent("a-radio-group");
      const _component_a_date_picker = _resolveComponent("a-date-picker");
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_radio = _resolveComponent("a-radio");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_unref(isType) ? '发布通知' : '查看通知'), 1), _createVNode(_component_a_form, {
        ref_key: "notificationRef",
        ref: notificationRef,
        model: notificationForm.value,
        disabled: disabled.value
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          name: "createUser",
          label: "发布人",
          required: ""
        }, {
          default: _withCtx(() => [_unref(isType) ? (_openBlock(), _createBlock(_component_a_select, {
            key: 0,
            value: notificationForm.value.createUser,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => notificationForm.value.createUser = $event),
            options: publisherList
          }, null, 8, ["value"])) : (_openBlock(), _createBlock(_component_a_input, {
            key: 1,
            value: notificationForm.value.createUser,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => notificationForm.value.createUser = $event)
          }, null, 8, ["value"]))]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "发送时间",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_a_radio_group, {
            value: notificationForm.value.isDelay,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => notificationForm.value.isDelay = $event),
            options: sendTypeList
          }, null, 8, ["value"]), notificationForm.value.isDelay && _unref(isType) ? (_openBlock(), _createBlock(_component_a_date_picker, {
            key: 0,
            "show-time": "",
            format: _unref(dateFormat),
            value: notificationForm.value.scheduleSendTime,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => notificationForm.value.scheduleSendTime = $event)
          }, null, 8, ["format", "value"])) : _createCommentVNode("", true), !_unref(isType) && notificationForm.value.isDelay == 1 ? (_openBlock(), _createBlock(_component_a_input, {
            key: 1,
            value: notificationForm.value.scheduleSendTime,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => notificationForm.value.scheduleSendTime = $event)
          }, null, 8, ["value"])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "强制弹窗",
          name: "isForcePopover",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_a_radio_group, {
            value: notificationForm.value.isForcePopover,
            "onUpdate:value": _cache[6] || (_cache[6] = $event => notificationForm.value.isForcePopover = $event),
            name: "isForcePopover"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_radio, {
              value: 1
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_a_input_number, {
                class: "input",
                id: "inputNumber",
                value: notificationForm.value.forcePopoverTimeLimit,
                "onUpdate:value": _cache[5] || (_cache[5] = $event => notificationForm.value.forcePopoverTimeLimit = $event),
                min: 1,
                max: 10
              }, null, 8, ["value"]), _hoisted_6])]),
              _: 1
            }), _createVNode(_component_a_radio, {
              value: 0
            }, {
              default: _withCtx(() => [_createTextVNode("否")]),
              _: 1
            })]),
            _: 1
          }, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "通知标题",
          name: "title",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: notificationForm.value.title,
            "onUpdate:value": _cache[7] || (_cache[7] = $event => notificationForm.value.title = $event),
            placeholder: "请输入通知标题"
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "通知正文",
          name: "content",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(NoEditor, {
            editorValue: notificationForm.value.content,
            "onUpdate:editorValue": _cache[8] || (_cache[8] = $event => notificationForm.value.content = $event),
            onSendImageUrlMap: getImageUrlMap,
            disabled: disabled.value
          }, null, 8, ["editorValue", "disabled"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "disabled"]), _unref(isType) ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_a_button, {
        onClick: toSystemNotification
      }, {
        default: _withCtx(() => [_createTextVNode("取消")]),
        _: 1
      }), _createVNode(_component_a_button, {
        type: "primary",
        onClick: sendSystemMessage
      }, {
        default: _withCtx(() => [_createTextVNode("发送")]),
        _: 1
      })])) : _createCommentVNode("", true)])]);
    };
  }
});